import { AspectRatio, Image, AspectRatioProps } from "@chakra-ui/react";
import { filestoreUrl, publicUrl } from "config";
import useCacheId from "hooks/useCacheId";
import { ImageSize } from "types";

type FancyBearImageProps = Omit<AspectRatioProps, "ratio"> & {
  tokenId: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const FancyBearImage = ({
  tokenId,
  size = "512",
  isDisabled = false,
  ...rest
}: FancyBearImageProps) => {
  const cacheId = useCacheId();

  return (
    <AspectRatio ratio={1} w="full" bg="bright.600" {...rest}>
      <Image
        src={`${filestoreUrl}/${size}/${tokenId}.png${
          cacheId ? `?cacheId=${encodeURIComponent(cacheId)}` : ""
        }`}
        fallbackSrc={`${publicUrl}/bear-placeholder_transparent.png`}
        fit="cover"
        opacity={isDisabled ? 0.5 : 1}
        transition="opacity 0.15s"
      />
    </AspectRatio>
  );
};

export default FancyBearImage;
